import { AuthService } from "./auth-service";

const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const axios = require("axios").default;

export class PostService {
  // PUT: The PUT method replaces all current representations of the target resource with the request payload.
  // PATCH: The PATCH method is used to apply partial modifications to a resource.

  static async getList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/post/`;
      const response = await axios.get(base_url, { params: params });
      // console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async getBackOfficeList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/back-office/post/`;
      const response = await axios.get(base_url, {
        params: params,
        // },
        // {
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      // console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async asyncDownloadBackOfficeFile(params) {
    //console.log("params: ", params);
    var qs = require("qs");

    try {
      const base_url = `${REACT_APP_DOMAIN}/api/download-file/`;
      const response = await axios({
        url: base_url,
        method: "GET",
        params: params,
        paramsSerializer: function (params) {
          return qs.stringify(params, { allowDots: true });
        },
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async checkCeleryTaskId(params) {
    //console.log("params: ", params);

    try {
      const base_url = `${REACT_APP_DOMAIN}/api/check-task-id/`;
      const response = await axios.get(base_url, {
        params: params,
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async getById(id) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/post/`;
      const response = await axios.get(`${base_url}${id}`);
      // console.log(response);
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  static async getCategoryList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/category/`;
      const response = await axios.get(base_url, { params: params });
      // console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  //Gestiti come hashtag
  static async getTagList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/tag/`;
      const response = await axios.get(base_url, { params: params });
      // console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async getTag(id) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/tag/`;
      const response = await axios.get(`${base_url}${id}`);
      //console.log('getTag: ', response);
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  static async updateTag(id, data) {
    try {
        const base_url = `${REACT_APP_DOMAIN}/api/tag/`
        const response = await axios.put(
            `${base_url}${id}/`,
            data,
            {
                headers: {
                    'Authorization': `Token ${AuthService.getWpProxyToken()}`
                }
            }
        );
        //console.log(response);
        return response;
    } catch (error) {
        console.error(error.response.data);
        return error.response;
    }
}

  static async getAuthorList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/author/`;
      const response = await axios.get(base_url, { params: params });
      // console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async updatePrice(id, params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/back-office/post/`;
      const response = await axios.put(
        `${base_url}${id}/change_price/`,
        params,
        {
          headers: {
            Authorization: `Token ${AuthService.getWpProxyToken()}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error(error.response.data);
      return error.response;
    }
  }
}
